import { useContext } from "react";
import Context from "./context";

const useCurrentProject = () => {
  const { current } = useContext(Context);
  return current;
};

export default useCurrentProject;
